// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"d7eeaac4","673":"98ea7ec2"}[chunkId] + "-" + {"245":"6334a658512762d5ce80","453":"9031039db1fe33256e0f","673":"56a031bc9c6293744d84"}[chunkId] + ".js";
};